import OPaymentProceedForm from './o-payment-proceed-form.vue';

export default OPaymentProceedForm;
